import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { platformCompaniesSelectors } from '../../../state/ducks/platformCompanies/selectors';
import { platformSuperAdminSelectors } from '../../../state/ducks/platformSuperAdmin/selectors';
import { RootState } from '../../../state/store/store';

type Props = {
    activeTenantId: string | null;
    tenantName: string | null;
    switchTenantView: (tenantId: string | null) => void;
};

const TenantViewBanner = ({ activeTenantId, tenantName, switchTenantView }: Props) => {
    if (!activeTenantId) return null;

    return (
        <Banner role="status">
            <span>
                Viewing as <strong>{tenantName || 'organization'}</strong>. Platform admin tools stay available; data is scoped to this tenant.
            </span>
            <ExitButton type="button" onClick={() => switchTenantView(null)}>
                Exit tenant view
            </ExitButton>
        </Banner>
    );
};

const Banner = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 8px 16px;
    background: #e6f7f8;
    border-bottom: 1px solid #b8e6e8;
    color: #1a3a3b;
    font-size: 13px;
`;

const ExitButton = styled.button`
    border: 1px solid #00b5b9;
    background: #fff;
    color: #008588;
    border-radius: 4px;
    padding: 4px 10px;
    font-size: 12px;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        background: #f0feff;
    }
`;

const mapState = (state: RootState) => {
    const activeTenantId = platformSuperAdminSelectors.activeTenantId(state);
    const companies = platformCompaniesSelectors.filteredCompanies(state);
    const tenant = companies.find((c) => c.id === activeTenantId);

    return {
        activeTenantId,
        tenantName: tenant?.name || tenant?.subDomain || null
    };
};

const mapDispatch = (dispatch: any) => ({
    switchTenantView: (tenantId: string | null) => dispatch.platformSuperAdmin.switchTenantView(tenantId)
});

export default connect(mapState, mapDispatch)(TenantViewBanner);
